import type { ApiResponse, WSSystemSyncResultData } from '@shared/types';
import { signedIdentityRequest } from './signedIdentityApi';

const SYSTEM_EVENTS_SCOPE = 'system events';

export const systemEventsApi = {
  list(
    payload: { since?: number; limit?: number },
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<WSSystemSyncResultData>> {
    return signedIdentityRequest({
      path: '/system-events/list',
      type: 'system-events:http:list',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: SYSTEM_EVENTS_SCOPE
    });
  },

  ack(
    payload: { syncedThrough: number },
    localIdentityId: string,
    serverUrl?: string
  ): Promise<ApiResponse<null>> {
    return signedIdentityRequest({
      path: '/system-events/ack',
      type: 'system-events:http:ack',
      payload,
      localIdentityId,
      serverUrl,
      scopeLabel: SYSTEM_EVENTS_SCOPE
    });
  }
};
